export default "__VITE_ASSET__RuuJpwFV__"